import React, { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useDispatch } from 'react-redux'
import {
  Box,
  Button,
  Typography,
  useTheme,
} from '@mui/material'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import { fetchTrackEvent, ProductAnalyticsEventTypes } from 'src/redux/productAnalytics'

const EmployerUserPendingApprovalStep = ({ wizardData }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const theme = useTheme()

  useEffect(() => {
    dispatch(
      fetchTrackEvent({
        eventName: 'signup_pending_approval_viewed',
        eventType: ProductAnalyticsEventTypes.ACTION,
        distinctId: wizardData.email,
        eventData: {
          employerId: wizardData.employerId,
          employerName: wizardData.employerName,
        },
      }),
    )
  }, [dispatch, wizardData.email, wizardData.employerId, wizardData.employerName])

  return (
    <Box sx={{ pt: 6, pb: 10 }}>
      <Box
        sx={{
          textAlign: 'center',
          background: `linear-gradient(135deg, ${theme.palette.success.light}15, ${theme.palette.primary.light}15)`,
          borderRadius: '16px',
          p: { xs: 4, md: 5 },
        }}
      >
        <CheckCircleOutlineIcon sx={{ fontSize: 80, color: 'success.main', mb: 2 }} />
        <Typography variant='h3' fontWeight={800} gutterBottom>
          Your healthcare system is already on MyStethi!
        </Typography>
        <Typography variant='body1' color='text.secondary' sx={{ maxWidth: 520, mx: 'auto', mb: 2 }}>
          Your request to join <strong>{wizardData.employerName}</strong> has been sent for approval.
          Once approved, you'll have full access to your organization's account.
        </Typography>
        <Typography variant='body2' color='text.secondary' sx={{ maxWidth: 520, mx: 'auto', mb: 4 }}>
          You'll receive an email once your account has been approved.
        </Typography>
        <Button
          variant='contained'
          size='large'
          onClick={() => navigate('/')}
        >
          Go to MyStethi
        </Button>
      </Box>
    </Box>
  )
}

export default EmployerUserPendingApprovalStep
